<svelte:options accessors/>
<script lang="ts">
    import NauiSlideOver from "../../naui/layout/NauiSlideOver.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {AppFilters} from "../../models/app-filters";
    import {createEventDispatcher} from "svelte";
    import {capitalize} from "../../utils";
    import NauiDateRange from "../../naui/atoms/NauiDateRange.svelte";

    export let filters: AppFilters;
    export let open = false;

    let dispatch = createEventDispatcher();
    let filterData: any = {
        term: '',
        date: '',
        type: '',
        status: ''
    }

    function apply() {
        if (filterData.term) {
            filters.setTerm(filterData.term);
        }
        if (filterData.date) {
            filters.setDate(filterData.date);
        }
        if (filterData.type) {
            filters.setType(filterData.type, capitalize(filterData.type));
        }
        if (filterData.status) {
            filters.setStatus(filterData.status.value, filterData.status.label);
        }
        filters = filters;

        dispatch('apply');

        for (const key of Object.keys(filterData)) {
            filterData[key] = '';
        }
        open = false;
    }

    function changeDate (ev) {
        filterData.date = ev.detail;
    }
</script>
    {#if filters}
<NauiSlideOver bind:open={open} maxWidth="500px" title="Buscar un pago">
    <div class="relative mb-2">
        <input type="text" class="naui-input w-100" bind:value={filterData.term} style="border-radius: 3rem; padding-left: 2.5rem;"
               placeholder="Buscar por No. Póliza o No. Placa">
        <span style="position: absolute; pointer-events: none; left:.5rem; top:.75rem;" class="material-icons-outlined secondary">search</span>
    </div>
    <div class="px-1">
        <div class="naui-field pt-0 mb-iii">
            <select class="naui-input w-100" bind:value={filterData.type}>
                <option selected hidden value="">Tipo</option>
                {#each filters.typeOptions as opt}
                    <option value={opt}>{opt}</option>
                {/each}
            </select>
            <span class="material-icons-outlined secondary">expand_more</span>
        </div>
        <div class="naui-field pt-0  mb-iii">
            <NauiDateRange label="Fecha vencimiento"
                           slug="date"
                           filter={true}
                           on:change={changeDate}
                           bind:value={filterData.date}/>
        </div>
        <div class="naui-field pt-0 mb-iii">
            <select class="naui-input w-100" bind:value={filterData.status}>
                <option selected hidden value="">Estado pago</option>
                {#each filters.statusOptions as option}
                    <option value={option}>{option.label}</option>
                {/each}
            </select>
            <span class="material-icons-outlined secondary">expand_more</span>
        </div>
    </div>
    <div class="action box py-15 min-w-200px">
        <NauiButton caption="APLICAR FILTROS" color="accent" mode="solid" on:click={apply}/>
    </div>
</NauiSlideOver>
{/if}
